import { Progress, Select } from "antd";
import iconCol1 from "../../../../Assets/Images/iconCollection1.png";
import { useEffect, useState } from "react";
import { httpService } from "../../../../services/httpService.service";

const Header = ({
  actualVisits,
  totalTargetVisits,
  selectedProjects,
  setSelectedProjects,
}) => {
  const [projects, setProjects] = useState([]);

  const getColor = (score, maxScore) => {
    if (!maxScore || maxScore === 0) return "#666666";
    const percent = (score / maxScore) * 100;
    const hue = (percent * 1.2).toFixed(0); // 0 (red) → 120 (green)
    return `hsl(${hue}, 100%, 42%)`;
  };

  const fetchProjects = () => {
    const contractId = localStorage.getItem("currentContractId");
    httpService.get(
      `/api/projects/getAll?contractId=${contractId}&pageSize=1000&pageNumber=1`,
      (res) => {
        setProjects(res.data);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const percent = totalTargetVisits
    ? (actualVisits / totalTargetVisits) * 100
    : 0;

  const color = getColor(actualVisits, totalTargetVisits);

  return (
    <div className="visitsOverviewSummary">
      <div className="header">
        <div className="titleContainer flex-wrap">
          <div className="title">
            <img src={iconCol1} alt="Overview Icon" /> <h2>Visits Overview</h2>
          </div>
          <div>
            <Select
              style={{ width: 200 }}
              options={projects.map((project) => ({
                label: project.projectName,
                value: project.id,
              }))}
              mode="multiple"
              value={selectedProjects}
              onChange={(value) => setSelectedProjects(value)}
              showSearch
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              placeholder="Select a project"
            />
          </div>
        </div>

        <div className="status mt-2">
          <div>
            <span style={{ backgroundColor: "#BFBFBF" }} /> Target Visits
          </div>
          <div>
            <span style={{ backgroundColor: color }} /> Actual Visits
          </div>
        </div>
      </div>

      <div className="progressDesign flex-wrap">
        <div className="progressBarContainer">
          <h2 style={{ color }}>{percent.toFixed(2)}% actual</h2>
          <Progress
            percent={percent}
            showInfo={false}
            size={["100%", 10]}
            type="line"
            strokeColor={color}
          />
        </div>
        <div>
          <h2 style={{ color }}>
            {actualVisits} / {totalTargetVisits}
          </h2>
          <p>visits</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
